import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

@Component({
    selector: 'ridango-ui-dialog-layout',
    templateUrl: 'dialog-layout.component.html'
})

export class DialogLayoutComponent {
    @Input() title: string
    @Output() closeDialog = new EventEmitter()
    constructor(@Inject('ENV') public env: any) {}
}